import React, { Component } from 'react';
import PropTypes from 'prop-types';

class  XSelect extends Component{

    constructor(props) {
        super(props)
        this.props=props;
    }

    render(){
        const {
            className,
            id,
            style: styleProps,
            eleRef,
            onChange,
            onClick,
            onDoubleClick,
            multiple
        } = this.props;


        let style = {
            //textDecoration:'none',
        };
        style = Object.assign({}, style, styleProps || {});
        return(
            <select ref={eleRef} className={className} id={id} style={style} onChange={onChange} multiple={multiple}
                     onClick={onClick} onDoubleClick={onDoubleClick}   >{this.props.children}</select>
        )
    }

}


XSelect.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    eleRef: PropTypes.any,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    multiple: PropTypes.bool,
};

XSelect.defaultProps = {
    multiple:false
};

export default  XSelect;

